"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUploadcareGroupUrl = void 0;
const constants_1 = require("./constants");
/**
 * This method constructs a URL to download all images in the Gallery as a single archive.
 *
 * @param uuid Gallery UUID
 * @param title Filename for the saved archive. Usually it is the Gallery title.
 * @returns URL to an archive containing all of the images in the Gallery.
 */
function getUploadcareGroupUrl(uuid, title) {
    // UploadCare doesn't like slashes in filenames even in encoded form.
    return `${constants_1.ASSETS_URL}/${uuid}/archive/zip/${encodeURIComponent(title.replace(/\//g, '_'))}.zip`;
}
exports.getUploadcareGroupUrl = getUploadcareGroupUrl;
//# sourceMappingURL=getUploadcareGroupUrl.js.map